import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Badge, Tooltip, Icon } from 'antd';
import classNames from 'classnames';
import Moment from 'react-moment';
import IconWhatsapp from 'react-icons/lib/fa/whatsapp'
import IconGoogle from 'react-icons/lib/fa/google'

import './index.scss';

import { PLATFORM, REVIEW_STATUS } from '../../../../data/config/constants';
import { getAvatarBgClass } from '../../../../data/config/utils';
import { IconDesktop, IconAndroid, IconApple } from '../../../../data/assets/icons';
import { IMG_MESSENGER } from '../../../../data/assets/img';

export default class ConversationItem extends React.PureComponent {
  onClickChatItem = () => {
    const { chat_item, handleChatItemClicked } = this.props;
    if (chat_item && handleChatItemClicked) {
      handleChatItemClicked(chat_item);
    }
  };

  render() {
    const { chat_item, active, fade_in, fade_in_left, hide_avatar, event_permissions } = this.props;
    const title = chat_item && chat_item.udf1 ? chat_item.udf1 : "unknown";
    const avatarBgClass = getAvatarBgClass(title);
    return (
      <div className={classNames("ori-animated ori-relative ori-full-width ori-pad-15 ori-cursor-ptr ori-flex-row ori-t-border-light oriConversationItemContainer", { "ori-bg-default": active, "ori-fade-in-left": fade_in_left, "ori-fade-in": fade_in })} onClick={this.onClickChatItem}>
        {
          event_permissions.reviewChat && chat_item.reviewStatus && chat_item.reviewStatus === REVIEW_STATUS.COMPLETE &&
          <div className="ori-absolute ori-align-right-5">
            <Icon type="check-circle" className="ori-font-green ori-font-lg" />
          </div>
        }
        {
          !hide_avatar &&
          <div className="ori-animated ori-zoom-in ori-r-pad-10">
            <Badge className="avatarBadge" overflowCount={9} count={chat_item.unread_message_count ? chat_item.unread_message_count : 0}>
              <Avatar className={classNames("ori-uppercase ori-align-avatar-letter", { ...avatarBgClass })}>{title.charAt(0)}</Avatar>
            </Badge>
          </div>
        }
        <div className="ori-full-flex ori-overflow-hidden">
          <p className="ori-font-bold ">
            <span className="ori-capitalize">{title}</span>
            {
              chat_item.udf2 && <span>/{chat_item.udf2}</span>
            }
          </p>
          <Tooltip overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag" placement="topLeft" title="PSID">
            <p className="ori-font-light ori-font-xs ori-text-overflow-dotted">{chat_item.psid}</p>
          </Tooltip>
          {
            chat_item.sessionId &&
            <Tooltip overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag" placement="topLeft" title="Session Id">
              <p className="ori-font-light ori-font-xs ori-text-overflow-dotted">{chat_item.sessionId}</p>
            </Tooltip>
          }
          <div className="ori-full-width ori-font-xs ori-font-light lastMessage">
            <span>{chat_item.lastMessage}</span>
          </div>
          <div className="ori-flex-row">
            {
              chat_item.platform &&
              <div className=" ori-flex iconContainer">
                {
                  chat_item.platform === PLATFORM.WEBSITE &&
                  <Tooltip placement="bottomLeft" title={<span className="ori-font-xs">{chat_item.platform}</span>}>
                    <IconDesktop size={14} className="ori-font-light ori-r-mrgn-5" />
                  </Tooltip>
                }
                {
                  chat_item.platform === PLATFORM.ANDROID &&
                  <IconAndroid size={14} className="ori-font-light ori-r-mrgn-5" />
                }
                {
                  chat_item.platform === PLATFORM.IOS &&
                  <IconApple size={14} className="ori-font-light ori-r-mrgn-5" />
                }
                {
                  chat_item.platform === PLATFORM.WHATSAPP &&
                  <IconWhatsapp size={14} className="ori-font-light ori-r-mrgn-5" />
                }
                {
                  chat_item.platform === PLATFORM.GOOGLE_ANALYTICS &&
                  <IconGoogle size={14} className="ori-font-light ori-r-mrgn-5" />
                }
                {
                  chat_item.platform === PLATFORM.FACEBOOK &&
                  <img src={IMG_MESSENGER} alt="" className="ori-r-mrgn-5 messengerIcon" />
                }
              </div>
            }
            {
              chat_item.lastMessageTimeStamp &&
              <p className="ori-font-xs ori-font-light ori-full-flex">
                <Moment fromNow >{chat_item.lastMessageTimeStamp}</Moment>
              </p>
            }
          </div>
        </div>
      </div>
    );
  }
}

ConversationItem.propTypes = {
  chat_item: PropTypes.object.isRequired,
  active: PropTypes.bool,
  handleChatItemClicked: PropTypes.func,
  fade_in: PropTypes.bool,
  fade_in_left: PropTypes.bool,
  hide_avatar: PropTypes.bool,
  event_permissions: PropTypes.object,
};

ConversationItem.defaultProps = {
  chat_item: {},
  active: false,
  fade_in: false,
  fade_in_left: false,
  hide_avatar: false,
  event_permissions: {}
};



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/conversationitem/index.js